import React from 'react';
import { Home, Map, Trophy, Activity, User } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PRIMARY_COLOR = '#00e0c6';

const NavItem = ({ Icon, label, page, isActive, navigate }) => (
  <div 
    onClick={() => navigate(page)}
    className={`flex flex-col items-center text-xs font-semibold p-1 transition-colors duration-200 cursor-pointer`}
    style={{ color: isActive ? PRIMARY_COLOR : 'rgb(107 114 128)' }} 
  >
    <Icon className="w-6 h-6 mb-0.5" />
    <span>{label}</span>
  </div>
);


const Navbar = ({ activePage = '' }) => {
    const navigate = useNavigate();
    
    const navItems = [
        { label: '홈', Icon: Home, page: 'home' },
        { label: '코스', Icon: Map, page: 'course' },
        { label: '대결', Icon: Trophy, page: 'battle' },
        { label: '운동기록', Icon: Activity, page: 'workrecord' },
        { label: '내정보', Icon: User, page: 'user' },
    ];
    
    const currentPage = activePage.toLowerCase(); 

    return (
        <footer className="fixed bottom-0 left-0 right-0 max-w-md mx-auto bg-white border-t border-gray-100 shadow-2xl p-3 z-20">
            <div className="flex justify-around items-center">
                {navItems.map((item) => (
                    <NavItem 
                        key={item.label}
                        Icon={item.Icon}
                        label={item.label}
                        page={item.page}
                        isActive={item.page === currentPage}
                        navigate={navigate} 
                    />
                ))}
            </div>
        </footer>
    );
};

export default Navbar;